import { useEffect, useState } from 'react';
import { lazyHolderSingletonGetter, SubjectHolder } from '@maxtropy/components/es/lib/SubjectHolder';
import { getCurrentUser } from '../../api/openPlatform-user';
import { getFunctionPermission, getMenu, MenuEntry } from '../../api/menu';
import { buildOriginMenu, getFilterMenu } from '@/utils/utils';

export const getCurrent = lazyHolderSingletonGetter(() => new SubjectHolder(getCurrentUser));

export function resetMgmtCurrent() {
  getCurrent().resetData();
}

export function refreshCurrent(callback?: () => void) {
  getCurrent().refreshData(callback);
}

export function useCurrent() {
  const currentInstance = getCurrent();
  const [state, setState] = useState(currentInstance.current());

  useEffect(() => {
    const subcription = currentInstance.subscribe(setState);
    return () => {
      subcription.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return state;
}

export const getMgmtMenu = /*#__PURE__*/ lazyHolderSingletonGetter(() => new SubjectHolder(getMenu));

export function useMgmtMenuOption() {
  const currentInstance = getMgmtMenu();
  const [state, setState] = useState(currentInstance.current());

  useEffect(() => {
    const subcription = currentInstance.subscribe(setState);
    return () => {
      subcription.unsubscribe();
    };
  }, []);

  return state;
}

export const getMgmtPermissions = /*#__PURE__*/ lazyHolderSingletonGetter(
  () => new SubjectHolder(getFunctionPermission)
);

export function useMgmtPermissions() {
  const currentInstance = getMgmtPermissions();
  const [state, setState] = useState(currentInstance.current());

  useEffect(() => {
    const subcription = currentInstance.subscribe(setState);
    return () => {
      subcription.unsubscribe();
    };
  }, []);

  return state;
}

export const useMgmtMenu = (menuData: MenuEntry[]) => {
  const menuOption = useMgmtMenuOption();
  const permissions = useMgmtPermissions();
  const [menu, setMenu] = useState<MenuEntry[]>([]);

  useEffect(() => {
    if (menuOption && permissions && menuData) {
      const filterMenu = getFilterMenu(menuData, permissions);
      const buildMenu = buildOriginMenu(filterMenu, menuOption);
      setMenu(buildMenu);
    }
  }, [menuData, menuOption, permissions]);

  return menu;
};
